import { SVGProps } from 'react'

const TickIcon = (props: SVGProps<SVGSVGElement>) => {
  return (
    <svg
      width="24"
      height="17"
      viewBox="0 0 24 17"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <path
        d="M1.66797 9.77783L7.03145 15.0824C7.42106 15.4677 8.04821 15.4677 8.43783 15.0824L21.8902 1.77783"
        stroke={props.color ? props.color : '#7181FF'}
        strokeWidth="2.5"
        strokeLinecap="round"
      />
    </svg>
  )
}

export default TickIcon
